import { config } from "../config";
import { callGateway, type CallerIdentity } from "./gateway";

/**
 * A provider's own type and approval: radaccess GET
 * /access/operator/{ns}/kind (v1.68, 2026-09-18). RBAC operatorkind:read --
 * superadmin, Operator, Reseller, Support -- on the caller's own namespace or
 * a descendant. Three fields and never more; the legal name and upstream stay
 * behind operator:*, superadmin only.
 */
export interface ProviderKind {
  namespace: string;
  /** ISP | VNO | OPERATOR | CLOUD_TENANT */
  operatortype: string;
  active: boolean;
}

export const CLOUD_TENANT = "CLOUD_TENANT";

export async function getProviderKind(identity: CallerIdentity, ns: string, signal?: AbortSignal): Promise<ProviderKind | null> {
  const r = await callGateway<ProviderKind | null>(
    identity,
    config().gatewayBase,
    `/operator/${encodeURIComponent(ns)}/kind`,
    signal ? { signal } : {},
  );
  return r.data ?? null;
}
